import {gql} from "apollo-angular";
import {baseResponse, baseResponseGraphqlField} from "../../../base.graphql";


export const fillableFormFieldFields = `
id
uniqueId
name
label
type
isMandatory
size
order
isActive
groupSize
createdAt
options {
  id
  uniqueId
  name
  value
  isActive
  createdAt
}
`


export const CREATE_FILLABLE_FORM_FIELD = gql`
  mutation CreateFormFieldMutation($input: FormFieldsInputObjects) {
    createFormFieldMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${fillableFormFieldFields}
      }
    }
  }
`


export const UPDATE_FILLABLE_FORM_FIELD = gql`
  mutation UpdateFormFieldMutation($input: FormFieldsInputObjects) {
    updateFormFieldMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${fillableFormFieldFields}
      }
    }
  }
`

export const GET_FILLABLE_FFORM_FIELDS = gql`
  query GetFormFields($filtering: FormFieldsFilterInputObject) {
    getFormFields(filtering: $filtering) {
      ${baseResponseGraphqlField}
      data {
        ${fillableFormFieldFields}
      }
    }
  }
`


export const DELETE_FILLABLE_FORM_FIELD = gql`
  mutation DeleteFormFieldMutation($fieldUid: String!) {
    deleteFormFieldMutation(fieldUid: $fieldUid) {
      ${baseResponseGraphqlField}
    }
  }
`
// CITIZEN
export const CITIZEN_GET_FORM_FIELDS = gql`
  query CitizenGetFormFields($formUniqueId: String) {
    citizenGetFormFields(formUniqueId: $formUniqueId) {
      response{
        ${baseResponse}
      }
      data {
        ${fillableFormFieldFields}
      }
    }
  }
`;
